import { getContentId } from 'lib/auth';
import { queryString } from 'lib/format';

export function getPlayerUrl(props) {
    const {
        content,
        toURL = false,
        onSyndicatedPlayerPage = false,
        absoluteUrl = false,
        airingId = null,
        useLocationPathname = false,
        isHero = false,
        bucketId,
        groupId,
        flags,
        routing
    } = props;

    if (content) {
        const { basename, query: queryParams, pathname } = (routing && routing.locationBeforeTransitions) || {};
        const { categoryId, id } = queryParams || {};

        let contentId;
        if (isHero && id) {
            contentId = {id}
        } else if (airingId) {
            contentId = {id: airingId}
        } else {
            contentId = getContentId(content);
        }
          
        const query = {
            bucketId,
            groupId,
            ...contentId,
            ...flags
        };

        let routePath = onSyndicatedPlayerPage ? '/syndicated/player' : '/player';
        if ( useLocationPathname) {
            routePath = pathname
        }
       
        if (categoryId) {
            query.categoryId = categoryId;
        }

        if (toURL) {

            if (absoluteUrl) {
                const domain = window && window.location && window.location.hostname;
                if (domain) {
                    let port = window.location.port || '';
                    if (port !== '') {
                        port = `:${port}`;
                    }
                    return `http://${domain}${port}${basename}${routePath}${queryString(query)}`;
                }
            }
            return `${basename}${routePath}${queryString(query)}`;
        }

        return {
            pathname: routePath,
            query
        };
    }

    return null;
};



// WEBPACK FOOTER //
// ./app/lib/streamPicker/getPlayerUrl.js